import jwt from 'jwt-decode';

export default (token) => {
    try {
        return jwt(token);
    } catch (error) {
        return undefined;
    }
};
